import React from 'react';
import { useResponsive } from '../../../hooks/useResponsive';
import { WalletPage } from './WalletPage';
import { WalletPageMobile } from './WalletPageMobile';

const WalletPageWrapper: React.FC = () => {
  const { isMobile } = useResponsive();

  return isMobile ? <WalletPageMobile /> : <WalletPage />;
};

export default WalletPageWrapper; 